<template>
  <div id="app" class="loading">
    <Header/>
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import Header from "./components/Header";

export default {
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  components: {
    Header
    // Nav,
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  watch: {
    '$route': () => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
};
</script>

<style lang="stylus">
input::-webkit-input-placeholder{
  color:#d6d6d6;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
  color:#d6d6d6;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
  color:#d6d6d6;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
  color:#d6d6d6;
}
// .el-popover {
//     max-width: 288px;
//     color: #fff !important;
//     border: none !important;
//     box-shadow: 0 0 2px 0 rgba(0, 0, 0, .05), 0 0 50px 0 rgba(0, 0, 0, .07);
//     background: #4c4c4c !important;
// }

// .el-popover[x-placement^=bottom] .popper__arrow{
//     /*el-popover上边三角下层的颜色---也就是视觉上的边框*/
//     border-bottom-color: rgba(76, 76, 76, 1) !important;
// }
// .el-popover[x-placement^=bottom] .popper__arrow::after{
//     /*el-popover上边三角表层的颜色---也就是视觉上的角*/
//     border-bottom-color: rgba(76, 76, 76, 1) !important;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue